<template>
  <div class="bggl">
    <div class="top-content">
      <top-user></top-user>
    </div>
    <div class="bottom-content">
      <!-- 顶部水平菜单 -->
      <div class="menu-wrapper">
        <Menu mode="horizontal" theme="primary" :active-name="activeMenu" @on-select="handleMenuSelect">
          <template v-for="(item, index) in menuList">
            <!-- 如果 children 长度为 0，则使用 MenuItem -->
            <MenuItem v-if="!item.children || item.children.length === 0" :key="index" :name="item.url">
              <Icon :type="item.icon" />
              {{ item.name }}
            </MenuItem>
            <!-- 如果 children 长度大于 0，则使用 Submenu -->
            <Submenu v-else :key="index" :name="item.name">
              <template #title>
                <Icon :type="item.icon" />
                {{ item.name }}
              </template>
              <!-- 遍历子菜单 -->
              <MenuItem v-for="(child, childIndex) in item.children" :key="`${index}-${childIndex}`" :name="child.url">
                {{ child.name }}
              </MenuItem>
            </Submenu>
          </template>
        </Menu>
      </div>
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import topUser from "@/views/components/topUserV2/topUserV2.vue";
import menu from '@/utils/js/menu.js';

export default {
  name: "moneyPlan",
  components: { topUser },
  data() {
    return {
      menuList: menu.moneyPlan,
      activeMenu: "",
    };
  },
  created() {
  console.log("菜单数据：", this.menuList);
  
  // 获取所有菜单的 url（包括子菜单）
  const getAllMenuUrls = (menus) => {
    let urls = [];
    menus.forEach(item => {
      if (item.children && item.children.length > 0) {
        urls = urls.concat(item.children.map(child => child.url));
      } else {
        urls.push(item.url);
      }
    });
    return urls;
  };
  
  const allUrls = getAllMenuUrls(this.menuList);
  const currentRouteName = this.$route.name;
  
  // 如果当前路由不在菜单列表中，才跳转到默认页面
  if (!allUrls.includes(currentRouteName)) {
    const defaultMenu = this.menuList[0];
    const defaultUrl = defaultMenu.url || defaultMenu.name;
    this.activeMenu = defaultUrl;
    this.$router.push({ name: defaultUrl });
  } else {
    // 如果当前路由在菜单中，设置 activeMenu 为当前路由
    this.activeMenu = currentRouteName;
  }
},
  methods: {
    handleMenuSelect(name) {
      console.log("选中菜单：", name);
      this.activeMenu = name;
      // 如果是子菜单项，跳转到对应路由
      this.$router.push({ name: name });
    }
  }
};
</script>

<style lang="scss" scoped>
.bggl {
  width: 100%;
  height: 100vh;
  
  .top-content {
    width: auto;
    height: 60px;
  }
  
  .bottom-content {
    width: 100%;
    height: calc(100% - 80px);
    display: flex;
    flex-direction: column; // 改为上下结构
    gap: 10px;
    
    .menu-wrapper {
      width: 100%;
      background: #1E90FF;
      border-radius: 5px;
      padding: 0 20px;
      flex-shrink: 0;
      
      // 覆盖 iView 菜单样式
      .ivu-menu-primary {
        background: transparent;
        height: 50px;
        line-height: 50px;
        
        .ivu-menu-item,
        .ivu-menu-submenu {
          color: rgba(255, 255, 255, 0.8);
          
          &:hover {
            color: #fff;
            background: rgba(255, 255, 255, 0.1);
          }
          
          &.ivu-menu-item-active,
          &.ivu-menu-submenu-active {
            color: #fff;
            border-bottom-color: #fff;
          }
        }
        
        .ivu-menu-submenu .ivu-menu {
          background: #fff;
          border-radius: 0 0 4px 4px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          
          .ivu-menu-item {
            color: #333;
            line-height: 40px;
            height: 40px;
            
            &:hover {
              background: #f0f8ff;
              color: #1E90FF;
            }
            
            &.ivu-menu-item-active {
              color: #1E90FF;
              background: #f0f8ff;
            }
          }
        }
        
        // 调整子菜单弹出位置
        .ivu-menu-submenu .ivu-select-dropdown {
          padding: 5px 0;
          min-width: 120px;
        }
      }
    }
    
    .content {
      width: 100%;
      flex: 1;
      overflow: auto;
      padding: 0 20px;
      background: #f5f7fa;
      border-radius: 5px;
    }
  }
}
</style>